import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Register() {
    const [form, setForm] = useState({ username: '', email: '', password: '', confirm: '' });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [emailValid, setEmailValid] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const checkEmail = async (email) => {
        if (!email.includes('@')) return;
        try {
            const res = await axios.get('/check_email?email=' + email);
            setEmailValid(res.data.valid);
        } catch {
            setEmailValid(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (form.password !== form.confirm) {
            setError('Passwords do not match!');
            return;
        }
        if (form.password.length < 6) {
            setError('Password must be at least 6 characters!');
            return;
        }
        try {
            await axios.post('/api/register', form);
            setSuccess('Registration successful! Awaiting approval.');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setError(err.response?.data?.error || 'Registration error!');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-logo">
                    <img src="/static/img/logo.png" alt="S.I.M.E. Logo" />
                    <h2>S.I.M.E. Drawings</h2>
                    <p>Register</p>
                </div>

                {error   && <div className="flash error">{error}</div>}
                {success && <div className="flash success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username</label>
                        <input type="text" name="username"
                            value={form.username} onChange={handleChange}
                            placeholder="Username" required />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" name="email"
                            value={form.email}
                            onChange={handleChange}
                            onBlur={e => checkEmail(e.target.value)}
                            placeholder="Email" required
                            style={{ borderColor: emailValid === false ? '#d9534f' : emailValid === true ? '#219653' : '' }} />
                        {emailValid === false && <p style={{ color: '#d9534f', fontSize: '0.8rem' }}>Invalid email domain!</p>}
                        {emailValid === true  && <p style={{ color: '#219653', fontSize: '0.8rem' }}>Valid email!</p>}
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input type="password" name="password"
                            value={form.password} onChange={handleChange}
                            placeholder="Min 6 characters" required />
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input type="password" name="confirm"
                            value={form.confirm} onChange={handleChange}
                            placeholder="Repeat password" required />
                    </div>
                    <button type="submit" className="auth-btn">Register</button>
                </form>

                <p className="auth-link">
                    Already have an account? <a href="/login">Login</a>
                </p>
            </div>
        </div>
    );
}

export default Register;
